module.exports = __webpack_public_path__ + "img/video.0ad56315.svg";